<template>
  <canvas
    ref="ledpanel"
    :width="width"
    :height="height"
    :style="`position: absolute; left: ${left}px; top: ${top}px;`"
  />
</template>

<script>
export default {
  props: [
    'bridge',
    'width',
    'height',
    'left',
    'top',
    'led',
  ],

  data: () => ({
    interval: 0,
  }),

  mounted() {
    this.interval = setInterval(() => {
      this.handleInterval();
    }, 20);
  },

  methods: {
    ledTimer20msHandler() {
      let TimerSum;
      let CurrentColor = this.led.Color;

      TimerSum = this.led.TimerColor0 + this.led.TimerColor1 + this.led.TimerColor2 + this.led.TimerColor3;
      if (TimerSum > 0) {
        this.led.Timer += 2;
        if (this.led.Timer >= TimerSum) {
          this.led.Timer = 0;
        }

        if (this.led.Timer < this.led.TimerColor0) {
          if (this.led.Color != 0) {
            this.led.Color = 0;
            this.led.Timer = 0;
          }
        } else if (this.led.Timer < (this.led.TimerColor0 + this.led.TimerColor1)) {
          if (this.led.Color != 1) {
            this.led.Color = 1;
            this.led.Timer = this.led.TimerColor0;
          }
        } else if (this.led.Timer < (this.led.TimerColor0 + this.led.TimerColor1 + this.led.TimerColor2)) {
          if (this.led.Color != 2) {
            this.led.Color = 2;
            this.led.Timer = this.led.TimerColor0 + this.led.TimerColor1;
          }
        } else {
          if (this.led.Color != 3) {
            this.led.Color = 3;
            this.led.Timer = this.led.TimerColor0 + this.led.TimerColor1 + this.led.TimerColor2;
          }
        }
      } else {
        this.led.Color = 0;
        this.led.Timer = 0;
      }

      return this.led.Color !== CurrentColor;
    },

    handleInterval() {
      const redraw = this.ledTimer20msHandler();

      if (redraw) {
        const elCanvas = this.$refs.ledpanel;
        if (elCanvas) {
          const ctx = elCanvas.getContext('2d');

          ctx.save();

          try {
            ctx.clearRect(0, 0, elCanvas.width, elCanvas.height);
            if (this.led.Color == 0) {
              ctx.fillStyle = 'gray';
            } else if (this.led.Color == 1) {
              ctx.fillStyle = 'red';
            } else if (this.led.Color == 2) {
              ctx.fillStyle = 'green';
            } else if (this.led.Color == 3) {
              ctx.fillStyle = 'orange';
            } else {
              ctx.fillStyle = 'gray';
            }

            ctx.fillRect(0, 0, elCanvas.width, elCanvas.width);
          } finally {
              ctx.restore();
          }
        }
      }
    },
  },

};
</script>

<style>

</style>
